import React, { useCallback, useLayoutEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated from 'react-native-reanimated';
import { AppView, Button, ButtonGroup, CardView, rem, SCROLL_INDICATOR_INSETS, SettingsItem, withAnimatedNavigationHeader, } from 'design-system';
import { HEIGHT } from 'design-system/Button';
import { Chip } from 'design-system/Chip';
import { IconBoldCalendar, IconEmma, IconShieldDone, } from 'design-system/icons';
import IconEyeSlash from 'design-system/icons/IconEyeSlash';
import IconNoteCheck from 'design-system/icons/IconNoteCheck';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { SettingsItemIcon } from 'design-system/SettingsItemIcon';
import StatusBar from 'design-system/StatusBar';
import Text from 'design-system/Text';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { tierThemes } from 'features/premium/benefits';
import { Tier } from 'features/premium/entities';
const strings = {
    weWillNeverTakeYourMoney: 'We will never take your money',
    emmaIsCompletely: 'Emma is completely free to use and we will not charge you for any reason.',
    weUnderstand: 'We understand..',
    readMore: 'Read more about our security policy  👇🏻',
    manageSubscriptions: 'Manage subscriptions',
    stillWantToDelete: 'I still want to delete',
    stickWithEmma: 'I’ll stick with Emma',
};
const DeleteTrustScreen = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton />,
        });
    }, []);
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const paddingBottom = useMarginBottom('paddingBottom', HEIGHT * 2 + rem(24), paddingHorizontalStyle);
    const onPressDelete = useCallback(() => {
        navigation.navigateDeprecated('DeleteSupport');
    }, []);
    const onPressBack = useCallback(() => {
        navigation.popToTop();
    }, []);
    return (<AppView withFrame={false}>
          <StatusBar barStyle="dark-content" animated/>
          <Animated.ScrollView onScroll={scrollHandler} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} scrollEventThrottle={16} contentContainerStyle={paddingBottom}>
            <ScreenInfoHeader title={strings.weWillNeverTakeYourMoney} subTitle={strings.emmaIsCompletely} smallSubTitle/>
            <>
              <CardView noMarginTop withPadding>
                <View style={styles.priceHeaderContainer}>
                  <SettingsItemIcon iconSize={44}>
                    <IconEmma />
                  </SettingsItemIcon>
                  <Chip text="Your plan" Dark noMarginEnd/>
                </View>
                <Text Text-16>{tierThemes[Tier.free].name}</Text>
                <View style={styles.priceContainer}>
                  <Text Primary Numbers-24>
                    £0.00
                  </Text>
                  <Text TextThin-14 Gray style={styles.period}>
                    / free forever
                  </Text>
                </View>
              </CardView>
              <CardView noMarginTop title="Your information is safe and secure">
                <SettingsItem title="Your money is safe" description="We don’t have the ability to charge your bank account" icon={<IconShieldDone gradientKey="plus"/>}/>
                <SettingsItem title="No credential sharing" description="We don’t have access to your bank connection details" icon={<IconEyeSlash gradientKey="skyBlue"/>}/>
                <SettingsItem title="90 days consent" description="Every 90 days, we’ll ask you if you’re still happy to be connected to Emma" icon={<IconBoldCalendar gradientKey="ultimate"/>}/>
                <SettingsItem title="FCA & ICO registered" description="Emma is registered with the Financial Conduct Authority and compliant with the ICO, the UK’s data privacy body" icon={<IconNoteCheck gradientKey="orange"/>}/>
              </CardView>
            </>
          </Animated.ScrollView>
          <ButtonGroup type="floating" margins>
            <Button title={strings.stillWantToDelete} brandReversed onPress={onPressDelete} testID="deleteButton"/>
            <Button title={strings.stickWithEmma} brand onPress={onPressBack} testID="backButton"/>
          </ButtonGroup>
        </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    priceContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: rem(8),
    },
    priceHeaderContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: rem(16),
    },
    period: {
        marginLeft: rem(8),
    },
});
export default DeleteTrustScreen;
